// This file is automatically generated. Do not edit manually.

import { Contact } from "src/api/generated/erp/db/types/tables/contact";
import { DocumentConnectionView } from "src/api/generated/postgres/db/types/documents/tables/documentConnectionView";
import { SalespersonView } from "src/api/generated/erp/db/types/tables/salespersonView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOfferContractSigningApi {
	export async function getInitData(args: {
		customerOfferId: number;
	}): Promise<CustomerOfferContractSigningApi_InitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/contract/signing/getInitData",
			method: "POST",
			data: {
				customerOfferId: args.customerOfferId,
			},
		});
		return response as CustomerOfferContractSigningApi_InitData;
	}

	export async function beginContractSigningProcess(args: {
		customerOfferId: number;
		documentIdsToAttach?: Array<number>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/contract/signing/beginContractSigningProcess",
			method: "POST",
			data: {
				customerOfferId: args.customerOfferId,
				documentIdsToAttach: args.documentIdsToAttach,
			},
		});
		return response as void;
	}

	export async function tryDownloadAndSaveSignedContractDocument(args: {
		customerOfferId: number;
	}): Promise<CustomerOfferContractSigningApi_TryDownloadAndSaveSignedContractDocumentResponse> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/contract/signing/tryDownloadAndSaveSignedContractDocument",
			method: "POST",
			data: {
				customerOfferId: args.customerOfferId,
			},
		});
		return response as CustomerOfferContractSigningApi_TryDownloadAndSaveSignedContractDocumentResponse;
	}

	export async function deleteContractDocument(args: { customerOfferId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/contract/signing/deleteContractDocument",
			method: "POST",
			data: {
				customerOfferId: args.customerOfferId,
			},
		});
		return response as void;
	}
}

export const CustomerOfferContractSigningApi_TryDownloadAndSaveSignedContractDocumentResponseValues = [
	"SUCCESS",
	"NOT_YET_SIGNED",
	"NOT_FOUND",
] as const;

export type CustomerOfferContractSigningApi_TryDownloadAndSaveSignedContractDocumentResponse =
	(typeof CustomerOfferContractSigningApi_TryDownloadAndSaveSignedContractDocumentResponseValues)[number];

export interface CustomerOfferContractSigningApi_InitData {
	customerContacts: Array<Contact>;
	documents: Array<DocumentConnectionView>;
	salesPerson: SalespersonView | null | undefined;
}
